import { createReducer, on } from '@ngrx/store';
import * as PolicyHolderActions from './policyholder.actions';
import { PolicyHolder } from '../../interfaces/policyholder.model';
import { ResetAllStores } from '../app/app.actions';

export interface PolicyHolderState {
  entity: PolicyHolder | null;
  list: PolicyHolder[];
  loading: boolean;
  error: any;
}

export const initialState: PolicyHolderState = {
  entity: null,
  list: [],
  loading: false,
  error: null,
};



export const policyHolderReducer = createReducer(
  initialState,

  // REGISTER
  on(PolicyHolderActions.registerPolicyHolder, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),

  on(PolicyHolderActions.registerPolicyHolderSuccess, (state) => ({
    ...state,
    loading: false,
  })),

  on(PolicyHolderActions.registerPolicyHolderFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),

  // LOAD BY ID
  on(PolicyHolderActions.loadPolicyHolderById, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),

  on(PolicyHolderActions.loadPolicyHolderByIdSuccess, (state, { policyholder }) => ({
    ...state,
    entity: policyholder,
    loading: false,
  })),

  on(PolicyHolderActions.loadPolicyHolderByIdFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),

  // UPDATE
  on(PolicyHolderActions.updatePolicyHolder, (state) => ({
    ...state,
    loading: true,
  })),

  on(PolicyHolderActions.updatePolicyHolderSuccess, (state, { policyholder }) => ({
    ...state,
    entity: policyholder,
    loading: false,
  })),

  on(PolicyHolderActions.updatePolicyHolderFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),

  // LOAD ALL
on(PolicyHolderActions.loadAllPolicyHolders, (state) => ({
  ...state,
  loading: true,
  error: null,
})),

on(PolicyHolderActions.loadAllPolicyHoldersSuccess, (state, { policyholders }) => ({
  ...state,
  list: policyholders,
  loading: false,
})),

on(PolicyHolderActions.loadAllPolicyHoldersFailure, (state, { error }) => ({
  ...state,
  loading: false,
  error,
})),
  on(ResetAllStores, () => initialState),

);


